import { LOGO_URL, BRAND, LOCATIONS } from "@/data/content";
import { Facebook, Instagram, Linkedin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="relative bg-bone text-navy/70 py-16 border-t border-navy/10 overflow-hidden" data-testid="footer">
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-teal/[0.06] to-transparent pointer-events-none" />
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 relative">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <img src={LOGO_URL} alt="Swastik Healthcare" className="h-16 w-auto mb-4" />
            <p className="text-sm mt-3 max-w-xs">
              Diagnostics and doctor consultations, built around trust and precision.
            </p>
            <div className="flex gap-4 mt-6">
              <a data-testid="footer-facebook" href="#" className="hover:text-teal hover:-translate-y-0.5 transition-all duration-300"><Facebook size={18} /></a>
              <a data-testid="footer-instagram" href="#" className="hover:text-teal hover:-translate-y-0.5 transition-all duration-300"><Instagram size={18} /></a>
              <a data-testid="footer-linkedin" href="#" className="hover:text-teal hover:-translate-y-0.5 transition-all duration-300"><Linkedin size={18} /></a>
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-teal mb-4 font-semibold">Centres</p>
            <ul className="space-y-2 text-sm">
              {LOCATIONS.map((l) => (
                <li key={l.name}>{l.name}</li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-teal mb-4 font-semibold">Contact</p>
            <ul className="space-y-2 text-sm">
              <li><a href={`tel:${BRAND.phoneMain.replace(/\s/g, "")}`} className="link-underline inline-block hover:text-teal transition-colors">{BRAND.phoneMain}</a></li>
              <li>
                <a
                  href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(BRAND.whatsappMessage)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="link-underline inline-block hover:text-teal transition-colors"
                >
                  Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-teal mb-4 font-semibold">Quick Links</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#packages" className="link-underline inline-block hover:text-teal transition-colors">Health Packages</a></li>
              <li><a href="#doctors" className="link-underline inline-block hover:text-teal transition-colors">Specialists</a></li>
              <li><a href="#book" className="link-underline inline-block hover:text-teal transition-colors">Book Now</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy/10 mt-12 pt-6 text-xs text-navy/40">
          © 2026 Swastik Healthcare. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
